import { render, staticRenderFns } from "./Privilege.vue?vue&type=template&id=02321a8f&scoped=true"
import script from "./Privilege.vue?vue&type=script&lang=ts"
export * from "./Privilege.vue?vue&type=script&lang=ts"
import style0 from "./Privilege.vue?vue&type=style&index=0&id=02321a8f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02321a8f",
  null
  
)

export default component.exports